import api from './api';

export interface AdminConversation {
  id: string; // roomId
  type: 'BOOKING' | 'SUPPORT' | 'DIRECT';
  title: string;
  subtitle: string;
  lastMessage: string;
  lastMessageTime: string;
  participantIds: string[];
  supportTicketId?: string | null;
  bookingId?: string | null;
  supportTicket?: any | null;
  booking?: any | null;
}

export interface AdminMessage {
  id: string;
  roomId: string;
  senderId: string;
  content: string;
  mediaUrl?: string | null;
  readAt?: string | null;
  createdAt: string;
  sender?: {
    name: string | null;
    role: string;
  } | null;
}

export const getAdminConversations = async (): Promise<AdminConversation[]> => {
  const { data } = await api.get('/admin/chat/conversations');
  return data.data;
};

export const startAdminChat = async (payload: { targetUserId?: string; supportTicketId?: string }): Promise<any> => {
  const { data } = await api.post('/admin/chat/start', payload);
  return data.data;
};

export const getAdminMessages = async (roomId: string): Promise<AdminMessage[]> => {
  const { data } = await api.get(`/admin/chat/${roomId}`);
  return data.data;
};

export const sendAdminMessage = async (roomId: string, content: string, mediaUrl?: string): Promise<AdminMessage> => {
  const { data } = await api.post(`/admin/chat/${roomId}/send`, { content, mediaUrl });
  return data.data;
};
